/** Join class fragments, dropping falsy ones — the ui/ primitives' only helper. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
